import { ENV } from 'config/env';

/**
 * Lightweight logging wrapper. In production, info/debug are silenced while
 * errors are still surfaced (and can be wired to an external service later).
 */
const noop = () => {};

export const logger = {
  debug: ENV.IS_PRODUCTION ? noop : (...args) => console.debug('[JYOT]', ...args),
  info: ENV.IS_PRODUCTION ? noop : (...args) => console.info('[JYOT]', ...args),
  warn: (...args) => console.warn('[JYOT]', ...args),
  error: (...args) => {
    console.error('[JYOT]', ...args);
    // Hook point: send to Sentry/Datadog/etc.
  },
};

export default logger;
